import DOMPurify from "dompurify";

const UNSAFE_URI_SCHEME = /^(?:javascript|vbscript|livescript|mocha|data):/i;
const SAFE_IMAGE_DATA_URI = /^data:image\/(?:png|jpe?g|gif|webp|bmp);base64,/i;
const URI_ATTRIBUTES = ["href", "src", "xlink:href", "action", "formaction", "background", "poster"];

const EDITOR_ALLOWED_TAGS = [
    "a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "br",
    "caption", "cite", "code", "col", "colgroup", "data", "dd", "del", "details", "dfn", "div", "dl", "dt",
    "em", "figcaption", "figure", "footer", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr",
    "i", "img", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "nav", "ol", "optgroup",
    "option", "output", "p", "pre", "q", "rp", "rt", "ruby", "s", "samp", "section", "small", "source",
    "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "tfoot", "th", "thead", "time",
    "tr", "track", "u", "ul", "var", "video", "wbr"
];

const EDITOR_ALLOWED_ATTRS = [
    "align", "alt", "border", "cellpadding", "cellspacing", "cite", "class", "color", "cols", "colspan",
    "controls", "coords", "datetime", "default", "dir", "download", "face", "for", "headers", "height",
    "hidden", "href", "hreflang", "id", "kind", "label", "lang", "loop", "muted", "name", "open",
    "preload", "rel", "reversed", "rows", "rowspan", "scope", "shape", "size", "span", "spellcheck",
    "src", "srclang", "start", "style", "summary", "tabindex", "target", "title", "type", "usemap",
    "valign", "value", "width", "wrap", "data-.*"
];

const EDITOR_REMOVED_TAGS = [
    "script", "style", "iframe", "object", "embed", "noscript", "link", "base", "meta", "form", "input",
    "button", "select", "textarea", "keygen", "frame", "frameset", "applet", "template", "portal",
    "svg", "math"
];

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (!node || typeof node.getAttribute !== "function") {
        return;
    }

    URI_ATTRIBUTES.forEach((attribute) => {
        const value = node.getAttribute(attribute);

        if (!value) {
            return;
        }

        const normalized = value.replace(/[\u0000-\u0020]/g, "").toLowerCase();

        if (UNSAFE_URI_SCHEME.test(normalized) && !SAFE_IMAGE_DATA_URI.test(normalized)) {
            node.removeAttribute(attribute);
        }
    });
});

window.initEditor = function (selector, options, initialValue) {
    const locale = window.eBAConfig && window.eBAConfig.locale ? window.eBAConfig.locale : 'en';

    const normalizedLocale = locale.toLowerCase().replace(/_/g, '-');
    const baseLanguage = normalizedLocale.split('-')[0];
    const languageCandidates = [normalizedLocale.replace(/-/g, '_')];
    if (languageCandidates.indexOf(baseLanguage) === -1) {
        languageCandidates.push(baseLanguage);
    }

    const toolbarButtons = {
        moreText: {
            buttons: [
                'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize',
                'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'
            ],
            buttonsVisible: 3
        },
        moreParagraph: {
            buttons: [
                'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL',
                'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'
            ],
            buttonsVisible: 3
        },
        moreRich: {
            buttons: [
                'insertLink', 'insertTable', 'emoticons', 'specialCharacters'
                /*, 'insertImage', 'insertFile', 'insertVideo'*/
            ],
            buttonsVisible: 4
        },
        moreMisc: {
            buttons: [
                'undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'html'
                /*, 'getPDF', 'help'*/
            ],
            buttonsVisible: 3
        }
    };

    const defaultEvents = {
        initialized: function () {
            if (initialValue) {
                this.html.set(initialValue);
            }
        }
    };

    const mergedEvents = Object.assign({}, options.events || {}, defaultEvents);

    const mergedOptions = Object.assign({}, options, {
        key: 'nQE2uB1A1D1B1A2B1A5mEZXQUVJb1EZf1IWIAUKLJZMBQuD3E2D1C2C4G1I4F1A10C6==',
        language: baseLanguage,
        tabSpaces: 4,
        imageUpload: false,
        fileUpload: false,
        videoUpload: false,
        toolbarButtons: options.toolbarButtons || toolbarButtons,
        toolbarButtonsSM: options.toolbarButtons || toolbarButtons,
        toolbarButtonsXS: options.toolbarButtons || toolbarButtons,
        quickInsertButtons: ['insertLink', 'insertTable', 'ol', 'ul', 'hr'],
        events: mergedEvents,
        DOMPurify: DOMPurify,
        htmlAllowedTags: EDITOR_ALLOWED_TAGS,
        htmlAllowedAttrs: EDITOR_ALLOWED_ATTRS,
        htmlRemoveTags: EDITOR_REMOVED_TAGS
    });

    const createEditor = (language) => {
        mergedOptions.language = language;
        window.editor = new FroalaEditor(selector, mergedOptions);
    };

    const loadLanguage = (index) => {
        if (index >= languageCandidates.length) {
            createEditor('en');
            return;
        }
        const candidate = languageCandidates[index];
        import(`../libs/froalaEditor/js/languages/${candidate}.js`)
            .then(() => createEditor(candidate))
            .catch(() => loadLanguage(index + 1));
    };

    loadLanguage(0);
}

window.archiveManager = {
    filter: {
        isLoadedUsersLookup: false
    }
}
// JScript File
window.rowOn = function (row, color) {
    var style = '#FFFFCC';
    if (color) {
        style = color;
    }
    var currentBackground = row.style.backgroundColor;
    if (currentBackground != style) {
        row.style.oldbg = currentBackground;
        row.style.backgroundColor = style;
    }
};

window.rowOut = function (row, color) {
    var oldBackground = row.style.oldbg;
    if (color != undefined && color != null) {
        oldBackground = color;
    }
    if (oldBackground != undefined && oldBackground != null) {
        row.style.backgroundColor = oldBackground;
    }
};

window.convertToJson = function (data) {
    var cache = [];
    var returnValue = JSON.stringify(data, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                return;
            }
            cache.push(value);
        }
        return value;
    });

    return returnValue;
};

window.getHeight = function () {
    var myHeight = 0;
    if (typeof (window.innerWidth) == 'number') {
        //Non-IE
        myHeight = window.innerHeight;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        //IE 6+ in 'standards compliant mode'
        myHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        //IE 4 compatible
        myHeight = document.body.clientHeight;
    }
    return myHeight;
};

window.getWidth = function () {
    var myWidth = 0;
    if (typeof (window.innerWidth) == 'number') {
        //Non-IE
        myWidth = window.innerWidth;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        //IE 6+ in 'standards compliant mode'
        myWidth = document.documentElement.clientWidth;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        //IE 4 compatible
        myWidth = document.body.clientWidth;
    }
    return myWidth;
};

window.getElementByRel = function (_rel) {
    for (var z = 0; z < document.all.length; z++) {
        var obj = document.all[z];
        if (obj.rel == _rel)
            return obj;
    }
    return null;
};

window.IseBAControl = function (obj) {
    return typeof (obj) != 'undefined';
};

window.getBrowserNumberDecimalSeparator = function () {
    return (1 / 10).toString().charAt(1);
};

window.getBrowserNumberGroupSeparator = function () {
    return getBrowserNumberDecimalSeparator() == '.' ? ',' : '.';
};

window.convertNumberToString = function (number, numberDecimalSeparator, numberGroupSeparator, fractionDigits) {

    // check for missing parameters
    if (arguments.length == 0) {
        return '';
    }

    // check for missing parameters and use defaults if so
    if (arguments.length < 3 || numberGroupSeparator == undefined) {
        numberGroupSeparator = getBrowserNumberGroupSeparator();
    }
    if (arguments.length < 2 || numberDecimalSeparator == undefined) {
        numberDecimalSeparator = getBrowserNumberDecimalSeparator();
    }

    var num = new Number();

    if (typeof (number) == 'string') {
        num = convertStringToNumber(number, numberDecimalSeparator, numberGroupSeparator);
    }
    else if (typeof (number) == 'number') {
        num = number;
    }
    else {
        return '';
    }

    if (num == undefined || num == NaN || num.toString() == Number.NaN.toString()) {
        return '';
    }

    if (arguments.length == 4 && fractionDigits != undefined && typeof (fractionDigits) == 'number' && arguments != Number.NaN && arguments.toString() != Number.NaN.toString()) {
        var num2 = num.toFixed(fractionDigits);
        if (num != num2) {
            num = num2;
        }
    }

    // separate the whole number and the fraction if possible
    var arr = num.toString().split(getBrowserNumberDecimalSeparator());
    var decimalPart = (arr.length > 0 && arr[0] != null) ? arr[0].replace(getBrowserNumberGroupSeparator(), '') : '0'; // decimal
    var fractionPart = arr.length == 2 ? arr[1] : null; // fraction

    var sRegExp = new RegExp('(-?[0-9]+)([0-9]{3})');

    if (arguments.length >= 3 && numberGroupSeparator != undefined && numberGroupSeparator != null && numberGroupSeparator.length > 0) {
        while (sRegExp.test(decimalPart)) {
            decimalPart = decimalPart.replace(sRegExp, '$1' + numberGroupSeparator + '$2');
        }
    }

    //    if (fractionPart != null && fractionPart.length > 0) {
    //        fractionPart = fractionPart.replace(/0+$/, '');
    //    }

    return ((decimalPart == null || decimalPart.length == 0) ? '0' : decimalPart) + ((fractionPart != null && fractionPart.length > 0) ? (numberDecimalSeparator + fractionPart) : '');
};

window.convertStringToNumber = function (numberString, numberDecimalSeparator, numberGroupSeparator) {

    // check for missing parameters
    if (arguments.length == 0) {
        return Number.NaN;
    }

    if (typeof (numberString) == 'number') {
        return numberString;
    }
    else if (typeof (numberString) == 'string') {
        numberString = numberString.replace(/^\s+|\s+$/, '');
    }
    else {
        return Number.NaN;
    }

    // check for missing parameters and use defaults if so
    if (arguments.length < 3 || numberGroupSeparator == undefined) {
        numberGroupSeparator = getBrowserNumberGroupSeparator();
    }
    if (arguments.length < 2 || numberDecimalSeparator == undefined) {
        numberDecimalSeparator = getBrowserNumberDecimalSeparator();
    }

    var arr = numberString.split(numberDecimalSeparator);
    var decimalPart = (arr.length > 0 && arr[0] != null) ? arr[0] : '0'; // decimal
    var fractionPart = arr.length == 2 ? arr[1] : null; // fraction

    if (arguments.length >= 3 && numberGroupSeparator != undefined && numberGroupSeparator != null && numberGroupSeparator.length > 0) {
        while (decimalPart.indexOf(numberGroupSeparator) >= 0) {
            decimalPart = decimalPart.replace(numberGroupSeparator, '');
        }
    }

    numberString = decimalPart;
    if (fractionPart != null && fractionPart.length > 0)
        numberString += getBrowserNumberDecimalSeparator() + fractionPart;

    var number = new Number();
    number = parseFloat(numberString);

    return number;
};

window.ToNumber = function (numberString) {
    if (((typeof (numberString) == 'string') && (numberString.length == 0)) || numberString == '-')
        return 0;
    return convertStringToNumber(numberString, NumberDecimalSeparator, NumberGroupSeparator);
};

window.ToString = function (number, fractionDigits, useNumberGroupSeparator) {
    return convertNumberToString(number, NumberDecimalSeparator, useNumberGroupSeparator == true ? NumberGroupSeparator : "", fractionDigits);
};

window.filterNumeric = function (textBox, evt, allowFraction) {
    textBox.lastValue = textBox.value;
    evt = (evt) ? evt : ((window.event) ? event : null);
    if (evt) {
        var text = null;
        if (arguments.length == 1 && textBox != undefined && textBox != null) {
            text = textBox.value;
        }
        if (arguments.length < 3 || allowFraction == undefined || allowFraction == null) {
            allowFraction = true;
        }
        var charCode = (evt.charCode) ? evt.charCode :
            ((evt.keyCode) ? evt.keyCode :
                ((evt.which) ? evt.which : 0));

        var ch = String.fromCharCode(charCode);

        if (charCode < 32) {
            return true;
        }
        if ((charCode <= 57) && (charCode >= 48)) {
            if (!evt.shiftKey) {
                return;
            }
        }
        if ((ch == '-' && (text == undefined || text == null || text.indexOf(ch) < 0)) ||
            (allowFraction && ch == NumberDecimalSeparator && (text == undefined || text == null || text.indexOf(ch) < 0))) {
            return;
        }
        evt.returnValue = false;
        if (evt.preventDefault) evt.preventDefault();
        return false;
    }
};

window.formatNumeric = function (textBox, fractionDigits, useNumberGroupSeparator, editing) {
    if (editing && (ToNumber(textBox.value) == ToNumber(textBox.lastValue)))
        return;

    textBox.value = ToString(textBox.value, fractionDigits, useNumberGroupSeparator);

    textBox.lastValue = textBox.value;
};

window.getScrollPosition = function () {
    var x = 0;
    var y = 0;
    if (typeof (window.pageYOffset) == 'number') {
        x = window.pageXOffset;
        y = window.pageYOffset;
    }
    else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
        x = document.documentElement.scrollLeft;
        y = document.documentElement.scrollTop;
    }
    else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
        x = document.body.scrollLeft;
        y = document.body.scrollTop;
    }
    var position = { 'x': x, 'y': y }
    return position;
};

window.saveScrollPositionToHidden = function (hiddenId) {
    if (hiddenId != undefined && hiddenId != null) {
        var hidden = document.getElementById(hiddenId);
        if (hidden != undefined && hidden != null) {
            try {
                var position = getScrollPosition();
                if (position != undefined && position != null) {
                    hidden.value = position.x.toString() + ',' + position.y.toString();
                }
            }
            catch (e) {
            }
        }
    }
};

window.setScrollPositionFromHidden = function (hiddenId) {
    if (hiddenId != undefined && hiddenId != null) {
        var hidden = document.getElementById(hiddenId);
        if (hidden != undefined && hidden != null) {
            try {
                if (hidden.value != null && hidden.value.length >= 3 && hidden.value.indexOf(',') > 0) {
                    var strs = hidden.value.split(',');
                    if (strs.length == 2) {
                        var x = parseInt(strs[0]);
                        var y = parseInt(strs[1]);
                        window.scrollTo(x, y);
                    }
                }
            }
            catch (e) {
            }
        }
    }
};

String.format = function () {
    var s = arguments[0];
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        s = s.replace(reg, arguments[i + 1]);
    }

    return s;
};

window.dimSum = function (jq, dims) {
    // Opera returns -1 for missing min/max width, turn into 0
    var sum = 0;
    for (var i = 1; i < arguments.length; i++)
        sum += Math.max(parseInt(jq.css(arguments[i])) || 0, 0);
    return sum;
};


window.GetDif = function () {
    var dif = 0;
    if (!topBannerVisible)
        dif = 74;

    if (!topBarVisible)
        dif = dif + 27;

    return dif;
};

window.waitSplitter = true;
window.waitingSplitter = false;
window.buttonsHeight2;
window.divId2;

window.setMainMenuDivHeight = function (buttonsHeight, divId) {
    var div = document.getElementById(divId);
    if (div != null) {
        var height = getHeight() - buttonsHeight - 108 + GetDif();
        if (height < 0) {
            height = 0;
        }
        //div.style.height = height;        // otipirdamaz - 21.09.2012 - document mode 9 olarak set edilince çalışmıyordu
        $(div).css({ height: height });      // otipirdamaz - 21.09.2012 
    }
};

window.cookiesEnabled = function () {
    if (JavaScriptCookies) {
        var ce = (navigator.cookieEnabled) ? true : false;

        if (ce) {
            document.cookie = "testcookie";
            ce = (document.cookie.indexOf("testcookie") != -1) ? true : false;
        }
        return ce;
    }
    else {
        return false;
    }
};


window.formatTime = function (event, textBox, hasSecond) {
    //var lengthLimit = hasSecond == true ? 8 : 5;

    //var selectionInfo = getSelectionCustom(textBox);

    //if (textBox.value.indexOf(":") == 1 && !((selectionInfo.selectionStart == 0 && selectionInfo.selectionEnd == 0) || (selectionInfo.selectionStart == 1 && selectionInfo.selectionEnd == 1))) {
    //    if (lengthLimit == 5) {
    //        lengthLimit = 4;
    //    }
    //    else if (lengthLimit == 8) {
    //        lengthLimit = 7;
    //    }
    //}

    //var correctSelection = true;
    //var selection = textBox.value.slice(selectionInfo.selectionStart, selectionInfo.selectionEnd);
    //if (selection.indexOf(":") > -1) {
    //    correctSelection = false;
    //    if ((selectionInfo.selectionStart == 0 && selectionInfo.selectionEnd == lengthLimit) || (selectionInfo.selectionStart == 3 && selectionInfo.selectionEnd == 8) || (lengthLimit == 7 && selectionInfo.selectionStart == 2 && selectionInfo.selectionEnd == 7) || (selectionInfo.selectionStart == 0 && selectionInfo.selectionEnd == lengthLimit)) {
    //        correctSelection = true;
    //    }
    //}

    //if ((((event.charCode >= 48 && event.charCode <= 58) || (event.keyCode >= 48 && event.keyCode <= 58)) && textBox.value.length < lengthLimit)
    //    || (event.keyCode == 8 && event.charCode != 8) || (event.keyCode == 46 && event.charCode != 46)
    //    || (((event.charCode >= 48 && event.charCode <= 58) || (event.keyCode >= 48 && event.keyCode <= 58)) && textBox.value.length == lengthLimit && selectionInfo.selectionStart != selectionInfo.selectionEnd && correctSelection)) {
    //    var lastChar;
    //    if ((event.keyCode == 58 || event.charCode == 58) &&
    //        !((selectionInfo.selectionStart == 1 && selectionInfo.selectionEnd == 1) || (selectionInfo.selectionStart == 2 && selectionInfo.selectionEnd == 2)
    //        || (selectionInfo.selectionStart == 4 && selectionInfo.selectionEnd == 4) || (selectionInfo.selectionStart == 5 && selectionInfo.selectionEnd == 5))) {
    //        event.keyCode = 0;
    //        if (event.preventDefault) event.preventDefault();
    //        else event.returnValue = false;
    //    }
    //    else {
    //        if (textBox.value.length > 0) {
    //            lastChar = textBox.value.substring(textBox.value.length - 1, textBox.value.length);
    //        }

    //        var lastCharDigit = lastChar != ':';

    //        if ((event.charCode == 58 || event.keyCode == 58) && (lastChar == ':')) {
    //            event.keyCode = 0;
    //            if (event.preventDefault) event.preventDefault();
    //            else event.returnValue = false;
    //        }
    //        else {
    //            if (hasSecond) {
    //                if (textBox.value.length == lengthLimit - 6) {
    //                    if (event.keyCode != 46 && event.keyCode != 8 && !(event.charCode == 58 || event.keyCode == 58) && lastCharDigit) {
    //                        textBox.value += ":";
    //                    }
    //                } else if (textBox.value.length == lengthLimit - 3) {
    //                    if (event.keyCode != 46 && event.keyCode != 8 && !(event.charCode == 58 || event.keyCode == 58) && lastCharDigit && hasSecond && textBox.value.indexOf(":") == textBox.value.lastIndexOf(":")) {
    //                        textBox.value += ":";
    //                    }
    //                }

    //                if (textBox.value.length >= lengthLimit && !correctSelection) {
    //                    event.keyCode = 0;
    //                }
    //            }
    //            else {
    //                if (textBox.value.length == lengthLimit - 3) {
    //                    if (event.keyCode != 46 && event.keyCode != 8 && !(event.charCode == 58 || event.keyCode == 58) && lastCharDigit && textBox.value.indexOf(":") < 0) {
    //                        textBox.value += ":";
    //                    }
    //                }

    //                if (textBox.value.length >= lengthLimit && !correctSelection) {
    //                    event.keyCode = 0;
    //                }
    //            }
    //        }
    //    }
    //}
    //else {
    //    if ((event.keyCode != 37 && event.keyCode != 39) || event.charCode == 37 || event.charCode == 39) {
    //        if (event.preventDefault) event.preventDefault();
    //        else event.returnValue = false;
    //    }
    //    event.keyCode = 0;
    // }

    var ss = getSelectionCustom(textBox).selectionStart;
    var chCode = event.charCode;
    if ((ss == 2) || (hasSecond && ss == 5)) {//: kısmında
        if (chCode != 0) {
            if (chCode != String.fromCharCode(":")) {
                if (timeControl(ss + 1, chCode, hasSecond)) {
                    textBox.value = textBox.value + ":" + String.fromCharCode(chCode);
                    event.preventDefault();
                } else {
                    textBox.value = textBox.value + ":";
                    event.preventDefault();
                }
            }
        }
    }
    else {
        if (!timeControl(ss, chCode, hasSecond)) {
            event.preventDefault();
        }
    }
};

window.timeAllTxtCntrl = function (event, textBox, hasSecond) {
    if (!hasSecond) {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;
    } else {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\:?([0-5]\d)\s*$/;
    }
    if (!re.test(textBox.value)) {
        textBox.value = "";
    }
}

window.timeControl = function (ss, charCode, hasSecond) {
    if (!hasSecond) {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;
        var formatTime = "00:00";
    } else {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\:?([0-5]\d)\s*$/;
        var formatTime = "00:00:00";
    }
    var tmpTime = "";
    if (charCode != 0) { //tek indexte işlem yapılıyorsa ve silme yapılmıyorsa
        tmpTime = formatTime.replaceAt(ss, String.fromCharCode(charCode));
        if (!re.test(tmpTime)) {
            return false;
        }
    }
    return true;
}

String.prototype.replaceAt = function (index, character) {
    return this.substr(0, index) + character + this.substr(index + character.length);
}
String.prototype.replaceGap = function (iStart, iEnd, character) { //başlangıç bitiş indexine kadar olan string yerine verilen karakteri koyar
    var nStr = "";
    for (var i = 0; i < this.length; i++) {
        if (iStart == i) {
            while (i != iEnd) {
                i++;
                if (i + 1 == iEnd) {
                    nStr += character;
                }
            }
        }
        nStr += this[i];
    }
}

window.getSelectionCustom = function (inputBox) {

    if (inputBox || inputBox == undefined) return;
    if ("selectionStart" in inputBox) {

        return {
            selectionStart: inputBox.selectionStart,
            selectionEnd: inputBox.selectionEnd
        }
    }

    //and now, the blinkered IE way
    var bookmark = document.selection.createRange().getBookmark()
    var selection = inputBox.createTextRange()
    selection.moveToBookmark(bookmark)

    var before = inputBox.createTextRange()
    before.collapse(true)
    before.setEndPoint("EndToStart", selection)

    var beforeLength = before.text.length
    var selLength = selection.text.length

    return {
        selectionStart: beforeLength,
        selectionEnd: beforeLength + selLength
    }
}

window.getDocumentForm = function (formID) {
    var f = null;

    if (formID != undefined && formID != null) {
        f = document.forms[formID];
    }

    if (f == undefined || f == null) {
        f = document.forms[0];
    }

    return f;
};

window.submitForm = function (formID) {
    var f = getDocumentForm(formID);

    if (f != null && f != undefined) {
        if (!f.onsubmit || f.onsubmit()) {  //checking onsubmit validations...       
            if (window.showLoading)
                window.showLoading();
            f.submit();
        }
    }
};

window.tifViewerPagesDropDownListChanged = function (dropDownListId, imageFrameId, pageLinksArray, index, previousPageLinkId, nextPageLinkId) {
    var dropDownList = document.getElementById(dropDownListId);
    var imageFrame = document.getElementById(imageFrameId);
    var previousPageLink = document.getElementById(previousPageLinkId);
    var nextPageLink = document.getElementById(nextPageLinkId);

    if (dropDownList.selectedIndex != index) {
        dropDownList.selectedIndex = index;
    }

    imageFrame.src = pageLinksArray[index];
    previousPageLink.disabled = index == 0 ? 'disabled' : '';
    nextPageLink.disabled = index < (pageLinksArray.length - 1) ? '' : 'disabled';

    if (index > 0) {
        previousPageLink.onclick = function () {
            dropDownList.selectedIndex = index - 1;
            tifViewerPagesDropDownListChanged(dropDownListId, imageFrameId, pageLinksArray, index - 1, previousPageLinkId, nextPageLinkId);
        };
    }
    if (index < pageLinksArray.length - 1) {
        nextPageLink.onclick = function () {
            dropDownList.selectedIndex = index + 1;
            tifViewerPagesDropDownListChanged(dropDownListId, imageFrameId, pageLinksArray, index + 1, previousPageLinkId, nextPageLinkId);
        };
    }
};

window.setImageSize = function (imgid, maxwidth) {
    var img = document.getElementById(imgid);
    //alert(imgid + " " + img.naturalWidth);
    if (img.clientWidth > maxwidth) {
        img.width = maxwidth;
    }
    img.style["visibility"] = "visible";
};

window.FormulaManagerValues = [];

window.InitializeFormulaCache = function () {
    FormulaManagerValues = [];
}

window.AddValueToFormulaCache = function (control) {
    FormulaManagerValues.push(control.value);
}

window.CalculateFormulaAvg = function () {
    if (FormulaManagerValues.length > 0) {
        var sum = 0;
        for (var i = 0; i < FormulaManagerValues.length; i++) {
            sum = sum + ToNumber(FormulaManagerValues[i]);
        }
        return sum / FormulaManagerValues.length;
    }
    else {
        return 0;
    }
}

window.CalculateFormulaMin = function () {
    return Math.min.apply(Math, FormulaManagerValues);
}

window.CalculateFormulaMax = function () {
    return Math.max.apply(Math, FormulaManagerValues);
}

window.CalculateFormulaCount = function () {
    return FormulaManagerValues.length;
}

window.CalculateFormulaStDev = function () {
    var avg = CalculateFormulaAvg();
    var retval = 0;
    var count = 0;

    for (var i = 0; i < FormulaManagerValues.length; i++) {
        var rv = ToNumber(FormulaManagerValues[i]);
        retval += Math.pow(rv - avg, 2);
        count++;
    }

    return ToNumber(Math.sqrt(ToNumber(Math.abs(retval / (count - 1)))));
}

window.loadGlobalize = function (userCulture) {
    Globalize.locale(userCulture);
}

window.toRegionDate = function (date, useUTC = false) {
    return new Date(`${date}${useUTC ? 'Z' : ''}`).toLocaleString(window.eBAConfig?.locale ?? "tr-TR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
}

window.setStatusIcon = function (icon) {
    switch (icon) {
        case "started.png":
            return {
                icon: "mgc_play_circle_line",
                color: "#1cb454"
            };
        case "finished.png":
            return {
                icon: "mgc_stop_circle_line",
                color: "#e53333"
            };
        case "info.png":
            return {
                icon: "mgc_information_line",
                color: "#006cd8"
            };
        case "send.png":
            return {
                icon: "mgc_send_fill",
                color: "#5A26FF"
            };
        case "approve.png":
            return {
                icon: "mgc_check_circle_line",
                color: "#1cb454"
            };
        case "reject.png":
            return {
                icon: "mgc_close_circle_line",
                color: "#e53333"
            };
        case "draft.png":
            return {
                icon: "mgc_file_line",
                color: "#52657f"
            };
        case "processing.png":
            return {
                icon: "mgc_settings_5_line",
                color: "#5A26FF"
            };
        case "blank.png":
        case "default.png":
            return {
                icon: "mgc_lightning_line",
                color: "#52657f"
            };
        default:
            return {
                icon: "mgc_settings_5_line",
                color: "#52657f"
            };
    }
}

window.getInitials = function (text) {
    text = text.trim().split(/\s+/)
    return text[0].charAt(0).toUpperCase() + (text[1] ? text[1].charAt(0).toUpperCase() : '');
}

window.hexToRGB = function (hex) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3)
        hex = hex.split('').map(char => char + char).join('');

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgb(${r},${g},${b})`;
}

window.getTimeDiff = function (dateString) {
    const now = new Date();
    const inputDate = new Date(dateString);
    const differenceInSeconds = Math.floor((now - inputDate) / 1000);

    const months = Math.floor(differenceInSeconds / (3600 * 24 * 30));
    const weeks = Math.floor(differenceInSeconds / (3600 * 24 * 7));
    const days = Math.floor(differenceInSeconds / (3600 * 24));
    const hours = Math.floor((differenceInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((differenceInSeconds % 3600) / 60);
    const seconds = differenceInSeconds % 60;

    if (months > 0) {
        return `${months} ${i18n.findWord(1800870)}`;
    } else if (weeks > 0) {
        return `${weeks} ${i18n.findWord(1800871)}`;
    } else if (days > 0) {
        return `${days} ${i18n.findWord(1800872)}`;
    } else if (hours > 0) {
        return `${hours} ${i18n.findWord(1800873)}`;
    } else if (minutes > 0) {
        return `${minutes} ${i18n.findWord(1800874)}`;
    } else {
        return `${seconds} ${i18n.findWord(1800875)}`;
    }
}

window.getFileTypeIcon = function (extension) {
    switch (extension.toLowerCase()) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "bmp":
        case "tiff":
            return { code: "mgc_pic_line", color: "rgb(255, 146, 38)" };
        case "doc":
        case "docx":
            return { code: "mgc_doc_line", color: "rgb(24, 89, 189)" };
        case "xls":
        case "xlsx":
            return { code: "mgc_xls_line", color: "rgb(16, 123, 64)" };
        case "ppt":
        case "pptx":
            return { code: "mgc_ppt_line", color: "rgb(196, 62, 27)" };
        case "pdf":
            return { code: "mgc_pdf_line", color: "rgb(174, 11, 0)" };
        default:
            return { code: "mgc_file_line", color: "rgb(69, 74, 80)" };
    }
}

window.calculateHeight = function (target, extraHeight) {
    let height = $(window).height() - ($(target).offset().top + $(target).outerHeight());
    if (!extraHeight)
        extraHeight = 50;
    height -= extraHeight;
    return `${height}px`;
}

window.setDateGroup = function (inputDate) {
    const today = new Date();
    const todayWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    const inputDateWithoutTime = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());

    const oneDayBefore = new Date(todayWithoutTime);
    oneDayBefore.setDate(oneDayBefore.getDate() - 1);

    const sevenDaysBefore = new Date(todayWithoutTime);
    sevenDaysBefore.setDate(sevenDaysBefore.getDate() - 7);

    if (inputDateWithoutTime.getTime() === todayWithoutTime.getTime())
        return i18n.findWord(1700167);
    else if (inputDateWithoutTime.getTime() === oneDayBefore.getTime())
        return i18n.findWord(1800691);
    else if (inputDateWithoutTime.getTime() >= sevenDaysBefore.getTime())
        return i18n.findWord(1800693);
    else
        return i18n.findWord(1800839);
}

window.groupDataByDate = function (items, field) {
    items = items.sort((a, b) => new Date(b[field]) - new Date(a[field]));
    const grouped = items.reduce((groups, item) => {
        const groupKey = setDateGroup(new Date(item[field]));
        if (!groups[groupKey])
            groups[groupKey] = [];
        groups[groupKey].push(item);
        return groups;
    }, {});

    return Object.keys(grouped).map(group => ({
        group: group,
        rows: grouped[group]
    }));
}

window.scrollToTopWithoutAnimation = function (top) {
    $('#ContentMain').scrollTop(top);
}

window.isBase64Icon = function (icon) {
    return typeof icon === 'string' && /^data:image\/(png|jpeg|jpg|gif);base64,/.test(icon);
}